export const NUMBERABLE_TYPES = {
    DYNAMIC_NUMBER: 'App\\Models\\PhoneNumberPool',
    STATIC_NUMBER: 'App\\\Models\\\PhoneNumber',
}
